import React, { useEffect, useState } from "react";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
import DynamicTable from "../../../components/listing/DynamicTable";
import IconEdit from "../../../components/icons/IconEdit";
import IconTrash from "../../../components/icons/IconTrash";

import FiltroProductoContrato from "./FiltroProductoContrato";
import CrearProductoContrato from "./CrearProductoContrato";
import EditarProductoContrato from "./EditarProductoContrato";
import EliminarProductoContrato from "./EliminarProductoContrato";

import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";

export default function ListaProductosContrato() {
  // Paginación
  const [porPagina, setPorPagina] = useState(30);
  const [pagina, setPagina] = useState(1);
  const [totalBackend, setTotalBackend] = useState(0);

  // Datos
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Modales
  const [mostrarFiltros, setMostrarFiltros] = useState(false);
  const [mostrarCrear, setMostrarCrear] = useState(false);
  const [registroAEditar, setRegistroAEditar] = useState(null);
  const [registroAEliminar, setRegistroAEliminar] = useState(null);

  // Filtros
  const [filtros, setFiltros] = useState({
  contratoObj: null,
  productoObj: null,
  qnProducto: "",
  valorMontoDescuento: "",
  valorMonto: "",
});

  const [reloadKey, setReloadKey] = useState(0);

  // Carga de datos
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        let baseUrl = apiRoutes.contratoDetalle.listUrl({});
        if (baseUrl.includes("?")) baseUrl = baseUrl.split("?")[0];

        const queryParams = new URLSearchParams();
        queryParams.append("page", pagina - 1);
        queryParams.append("size", porPagina);
        if (filtros.contratoObj?.id) queryParams.append("contratoId", filtros.contratoObj.id);
if (filtros.productoObj?.id) queryParams.append("productoId", filtros.productoObj.id);
        if (filtros.qnProducto) queryParams.append("qnProducto", filtros.qnProducto);
        if (filtros.valorMontoDescuento) queryParams.append("valorMontoDescuento", filtros.valorMontoDescuento);
        if (filtros.valorMonto) queryParams.append("valorMonto", filtros.valorMonto);

        const url = `${baseUrl}?${queryParams.toString()}`;
        const res = await appFetchJson(url);

        const items = Array.isArray(res?.items) ? res.items : (Array.isArray(res?.content) ? res.content : []);
        setData(items);
        const total = res?.totalElements ?? res?.total ?? items.length;
        setTotalBackend(total);
      } catch (e) {
        console.error("Error cargando productos de contrato:", e);
        setError("Error al cargar los datos.");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [pagina, porPagina, filtros, reloadKey]);

  // Helper para formatear números
  const formatNumber = (val) => {
    if (val === null || val === undefined) return "";
    return new Intl.NumberFormat("es-PY").format(val);
  };

  // Definición de columnas
  const columns = [
    {
      header: "Contrato",
      accessor: "contratoCodigo",
      type: "text",
      width: "15%",
      cellClass: "font-medium text-gray-800",
    },
    {
      header: "Producto",
      accessor: "productoNombre",
      type: "text",
      width: "20%",
      cellClass: "whitespace-normal break-words",
    },
    {
      header: "Cantidad de Producto",
      accessor: "qnProducto",
      type: "text",
      width: "12%",
      cellClass: "text-center",
      render: (item) => formatNumber(item.qnProducto),
    },
    {
      header: "Valor de Descuento Producto",
      accessor: "valorMontoDescuento",
      type: "text",
      width: "12%",
      cellClass: "text-center",
      render: (item) => formatNumber(item.valorMontoDescuento),
    },
    {
      header: "Cantidad Producto Utilizado",
      accessor: "qnUtilizado",
      type: "text",
      width: "12%",
      cellClass: "text-center",
      render: (item) => formatNumber(item.qnUtilizado),
    },
    {
      header: "Valor de Monto PYG",
      accessor: "valorMonto",
      type: "text",
      width: "12%",
      cellClass: "text-center",
      render: (item) => formatNumber(item.valorMonto),
    },
    {
      header: "Valor de Monto PYG Utilizado",
      accessor: "valorMontoUtilizado",
      type: "text",
      width: "12%",
      cellClass: "text-center",
      render: (item) => formatNumber(item.valorMontoUtilizado),
    },
    {
      header: "Acción",
      type: "action",
      width: "8%",
      render: (item) => (
        <div className="flex justify-center items-center gap-2">
          {/* <button
            className="p-1"
            title="Editar"
            onClick={() => setRegistroAEditar(item)}
          >
            <IconEdit size={16} />
          </button> */}

          <button
            className="p-1"
            title="Eliminar"
            onClick={() => setRegistroAEliminar(item)}
          >
            <IconTrash size={16} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page">
      <ListHeader
        title="Productos del Contrato"
        filters={filtros}
        onFilterClick={() => setMostrarFiltros(true)}
        onClearFilters={() => {
  setFiltros({
    contratoObj: null,
    productoObj: null,
    qnProducto: "",
    valorMontoDescuento: "",
    valorMonto: "",
  });
  setPagina(1);
}}
        showAdd={false}
        addLabel="Nuevo Producto en Contrato"
        onAddClick={() => setMostrarCrear(true)}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
      />

      {loading && <div className="mt-2 text-sm text-center text-gray-600">Cargando datos...</div>}
      {error && <div className="mt-2 text-sm text-red-600">{error}</div>}

      {mostrarFiltros && (
        <FiltroProductoContrato
          initialFilters={filtros}
          onSubmit={(nuevosFiltros) => {
            setFiltros(nuevosFiltros);
            setPagina(1);
            setMostrarFiltros(false);
          }}
          onClose={() => setMostrarFiltros(false)}
        />
      )}

      {!loading && <DynamicTable size="M" data={data} columns={columns} />}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={totalBackend}
        onPageChange={(p) => setPagina(p)}
      />

      {/* Modal Crear */}
      {mostrarCrear && (
        <CrearProductoContrato
          onClose={() => setMostrarCrear(false)}
          onCreated={() => {
            setReloadKey((k) => k + 1);
            setMostrarCrear(false);
          }}
        />
      )}

      {/* Modal Editar */}
      {registroAEditar && (
        <EditarProductoContrato
          initial={registroAEditar}
          onClose={() => setRegistroAEditar(null)}
          onSaved={() => {
            setReloadKey((k) => k + 1);
            setRegistroAEditar(null);
          }}
        />
      )}

      {/* Modal Eliminar */}
      {registroAEliminar && (
        <div className="modal-backdrop" onClick={() => setRegistroAEliminar(null)}>
          <div className="modal-panel-md" onClick={(e) => e.stopPropagation()}>
            <EliminarProductoContrato
              registro={registroAEliminar}
              onClose={() => setRegistroAEliminar(null)}
              onDeleted={() => {
                setReloadKey((k) => k + 1);
                setRegistroAEliminar(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}